/* eslint-disale */
import { lazy } from 'react';
import { Switch } from 'react-router-dom';
import { Route, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const MessengerMessageSummery = lazy(() => import('../../container/conversation/overview/MessengerMessageSummery_v2'));
const SinglePostView = lazy(() => import('../../container/conversation/overview/SinglePostView'));

function MessengerRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/summery/messenger/v1/:id`} component={MessengerMessageSummery} />
      <Route path={`${path}/posts/view/v1/:id`} component={SinglePostView} />
    </Switch>
  );
}

export default MessengerRoutes;
